import { render, staticRenderFns } from "./CustomerInfos.vue?vue&type=template&id=4fce41ea&scoped=true"
import script from "./CustomerInfos.vue?vue&type=script&lang=js"
export * from "./CustomerInfos.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfos.vue?vue&type=style&index=0&id=4fce41ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce41ea",
  null
  
)

export default component.exports